export function schema_zone_extract() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			params: {
				title: "Paramètres sous forme de JSON",
				type: "string",
				format: "json",
			},
		},
	};
}
